import { combineReducers } from "redux";

import * as accountCreditRedeem from "./accountCreditRedeem";
import * as coupon from "./coupon";
import * as coupons from "./coupons";
import * as isGetRewardsLoading from "./isGetRewardsLoading";
import * as ledgerHead from "./ledgerHead";
import * as requestStatus from "./requestStatus";
import * as rewards from "./rewards";
import * as rewardStats from "./rewardStats";
import * as shopifyActiveDiscounts from "./shopifyActiveDiscounts";
import * as shopifyActiveGiftCards from "./shopifyActiveGiftCards";
import * as shopifyVariants from "./shopifyVariants";

export const reducer = combineReducers({
  accountCreditRedeem: accountCreditRedeem.reducer,
  coupon: coupon.reducer,
  coupons: coupons.reducer,
  isGetRewardsLoading: isGetRewardsLoading.reducer,
  ledgerHead: ledgerHead.reducer,
  requestStatus: requestStatus.reducer,
  rewards: rewards.reducer,
  rewardStats: rewardStats.reducer,
  shopifyActiveDiscounts: shopifyActiveDiscounts.reducer,
  shopifyActiveGiftCards: shopifyActiveGiftCards.reducer,
  shopifyVariants: shopifyVariants.reducer,
});

export interface StoreState {
  accountCreditRedeem: accountCreditRedeem.StoreState;
  coupon: coupon.StoreState;
  coupons: coupons.StoreState;
  isGetRewardsLoading: isGetRewardsLoading.StoreState;
  ledgerHead: ledgerHead.StoreState;
  requestStatus: requestStatus.StoreState;
  rewards: rewards.StoreState;
  rewardStats: rewardStats.StoreState;
  shopifyActiveDiscounts: shopifyActiveDiscounts.StoreState;
  shopifyActiveGiftCards: shopifyActiveGiftCards.StoreState;
  shopifyVariants: shopifyVariants.StoreState;
}
